// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-p_ft","advertDetailParameterList__header":"c-p_fu","advertDetailParameterList__list":"c-p_fv"};